import { httpClient } from '@bcba/client-auth';
import { baseCropPledgePath } from '.';

export const markAsPaidCropPledge = async (uuid: string) => {
  await httpClient.post(`${baseCropPledgePath}/${uuid}/paid`);
};
